<script>
// 二级弹窗混合组件
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      boxData  : {
        judgeBox : false, // 控制盒子开启关闭
        Zindex   : 0,     // 盒子层级
        data     : null,  // 盒子数据
        moveoks  : false, // 拖动判读啊数据
        oldMove  : {      // 计算移动增量
          x : 0,
          y : 0
        },
        fix : {           // 弹窗位置
          x : 0,
          y : 0
        }
      },
      boxDataName : ''   // 弹窗名称
    };
  },
  watch : {
    'SelectScenes_Msg' : function(val, oldval){ // 判断打开关闭
      if(this.boxData.judgeBox){
        this.close();
      }
    },
  },
  props: ['dataMsg', 'boxDatas'],
  computed: {
    ...mapGetters([
      'TopNav_Size',
      'TOOL',
      'SelectScenes_Msg',
    ])
  },
  mounted () {
    this.$bus.on('Document_mousemove_vue',(event) => {
      let e = event ? event: window.event;
      if(this.boxData.moveoks){
        this.moveArea(e);
        return false;
      }
    });
    this.$bus.on('Document_mouseup_vue',(event) => {
      let e = event ? event: window.event;
      if(this.boxData.moveoks){
        this.saveMoveState(e);
        return false;
      }
    })
  },
  methods: {
    moveStart(e){         // 移动启动
      this.boxData.moveoks = true;
      this.boxData.oldMove = {
        x : e.pageX,
        y : e.pageY,
      }
      e.onselectstart = () => { //防止IE文字选中
				return false;
			}
    },
    moveArea(e){         // 拖动元素计算
      if(this.boxData.moveoks){
        let Incremental = {
          x : this.boxData.oldMove.x - e.pageX,
          y : this.boxData.oldMove.y - e.pageY,
        }
        this.boxData.oldMove = {
          x : e.pageX,
          y : e.pageY,
        }
        this.boxData.fix = {
          x : this.boxData.fix.x - Incremental.x,
          y : this.boxData.fix.y - Incremental.y,
        }
      }
    },
    saveMoveState(e){    // 保存移动状态
      this.boxData.moveoks = false;
    },
    close(){             // 关闭画框
      this.boxData.data     = null;  // 盒子数据
      this.boxData.moveoks  = false; // 拖动判读啊数据
      this.boxData.oldMove  = {      // 计算移动增量
        x : 0,
        y : 0
      };
      this.boxData.fix = {           // 弹窗位置
        x : 0,
        y : 0
      };
      this.$bus.emit('FeaturesPop_close_vue',{
				name : this.boxDataName,
				type : 2
      });
      this.$bus.emit('subtitlePopupClose',{
				name : this.boxDataName,
				type : 2
			});
    },
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/mixins/popupSecond.vue